import { mutate } from 'swr';

/**
 * KPIGrid's data (`usePortfolioSummary`) lives in a separate SWR cache from
 * the React Query caches used by signal/task mutations, so completing a task
 * or acting on a signal never touched it — KPI cards only updated on the
 * 5-minute SWR poll. Call this after those mutations succeed so the cards
 * reflect the change immediately.
 */
export function refreshPortfolioSummary() {
  return mutate(
    (key) => Array.isArray(key) && typeof key[0] === 'string' && key[0].startsWith('/api/portfolio/summary'),
    undefined,
    { revalidate: true }
  );
}
